import React, { useState, useEffect } from "react";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, Col, Accordion, Card, Row, Spinner } from "react-bootstrap";
import _ from "lodash";
import ApiAmusementService from "../../../core/api/api.amusementService";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGridAmusementServices from "./DataGridAmusementServices";
import ApiAmusementGroup from "../../../core/api/api.amusementGroup";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import { tools } from "../../../core/utils/tools";
import SelectComponent from "../_Components/ReactSelectComponent";
import GlobalFormControl from "../_Components/GlobalFormControl";
import ApiRegion from "../../../core/api/api.region";

const AmusementService = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [listData, setListData] = useState({});
  const [listAmusementGroup, setListAmusementGroup] = useState([]);
  const [allAmusementCityList, setAllAmusementCityList] = useState([]);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});

  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;
  const cityIdFromUrl1 = searchParams.get("cityIdList");
  const groupIdFromUrl1 = searchParams.get("groupIdList");
  useEffect(() => {
    (async () => {
      try {
        const data = await ApiAmusementService.getAll({
          pageSize: !_.isEmpty(pageSizeFromUrl) ? getValues("pageSize") : pageSizeFromUrl,
          pageNumber: !_.isEmpty(pageNumberFromUrl) ? getValues("pageNumber") : pageNumberFromUrl,
          globalSearch: searchParams.get("globalSearch"),
          cityIdList: _.isEmpty(cityIdFromUrl1) ? null : cityIdFromUrl1,
          groupIdList: _.isEmpty(groupIdFromUrl1) ? null : groupIdFromUrl1,
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
        const result = await ApiAmusementGroup.getAllGroups();
        setListAmusementGroup(result);
        const response = await ApiRegion.getAllCity();
        setAllAmusementCityList(response);
        const formInputs = [
          { name: "cityIdList", type: "multiSelect", isMulti: true, data: response },
          { name: "groupIdList", type: "multiSelect", isMulti: true, data: result.data },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      }
    })();
  }, []);
  const onSubmit = async (data) => {
    if (data.cityIdList?.length > 0) data.cityIdList = _.toString(data.cityIdList?.map((item) => item.value));
    if (data.groupIdList?.length > 0) data.groupIdList = _.toString(data.groupIdList?.map((item) => item.value));

    tools.setPageNumber(data, searchParams, setValue);
    const apiData = await ApiAmusementService.getAll(data)
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/amusementService?${queryString}`);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
  };

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت سرویس تفریحات</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست سرویس های ثبت شده</span>
          </h3>
          <div className="card-toolbar">
            <Link
              to={{
                pathname: `/createOrEditService/0`,
              }}
              className="btn btn-primary"
            >
              <AddCircle className="mr-1" />
              ایجاد سرویس جدید
            </Link>
          </div>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                {/* {Serach} */}
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link">
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Card.Body>
                        <Row>
                          <Col sm="6" xl="3" className="tb-reponsive ">
                            <Controller
                              name="cityIdList"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className=" mt-2"
                                  placeholder="انتخاب شهر"
                                  options={allAmusementCityList?.map((item) => ({
                                    value: item.id,
                                    label: item.id + "-" + item.name,
                                  }))}
                                  isMulti
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive ">
                            <Controller
                              name="groupIdList"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className=" mt-2"
                                  placeholder="انتخاب گروه تفریح"
                                  options={listAmusementGroup?.map((item) => ({ value: item.id, label: item.title }))}
                                  isMulti
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" className="tb-reponsive mt-3">
                            <Button variant="success" type="submit" disabled={isSubmitting}>
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                    <SearchIcon />{" "}
                  </Button>
                </InputGroup>
              </div>

              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                <DataGridAmusementServices data={listData} />
              </Col>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default AmusementService;
